import * as React from "react";
import { Button } from "azure-devops-ui/Button";
import { FocusGroupContext } from "azure-devops-ui/FocusGroup";
import { FocusZone, FocusZoneContext, FocusZoneDirection } from "azure-devops-ui/FocusZone";

export default class FocusGroupExample extends React.Component {
    public render(): JSX.Element {
        return (
            <div style={{ margin: "8px" }}>
                <FocusZone
                    circularNavigation={true}
                    direction={FocusZoneDirection.Vertical}
                    focusGroupProps={{ defaultElementId: "Button2-id" }}
                >
                    <div className="flex-column">
                        {this.getChild("Button1")}
                        {this.getChild("Button2")}
                        {this.getChild("Button3")}
                        {this.getChild("Button4")}
                    </div>
                </FocusZone>
            </div>
        );
    }

    private getChild(label: string): JSX.Element {
        const id = label + "-id";
        return (
            <FocusGroupContext.Consumer>
                {focusGroupContext => (
                    <FocusZoneContext.Consumer>
                        {zoneContext => {
                            return (
                                <div style={{ paddingBottom: "8px" }}>
                                    <Button
                                        data-focuszone={zoneContext.focuszoneId}
                                        tabIndex={
                                            focusGroupContext.focusedElementId === id ? 0 : -1
                                        }
                                        onFocus={() => focusGroupContext.onFocus(id)}
                                        id={id}
                                    >
                                        {label}
                                    </Button>
                                </div>
                            );
                        }}
                    </FocusZoneContext.Consumer>
                )}
            </FocusGroupContext.Consumer>
        );
    }
}
